export default "__VITE_ASSET__BMAaGq9S__"